import { Close, EditOutlined } from '@mui/icons-material';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import { setGeofenceChangedItem, setGeofenceUpdateItem } from 'app/actions/map';
import { Protect } from 'app/components';
import { ChangeGeofenceShapeIcon, DeleteIcon } from 'app/icons';
import React from 'react';
import { Popup } from 'react-leaflet';
import { useDispatch } from 'react-redux';

const MapLeafletGeofencePopup = (props) => {
  const dispatch = useDispatch();
  const { value, onClose } = props;

  const handleChangeClick = (value) => dispatch(setGeofenceChangedItem(value));

  const handleUpdateClick = (value) => dispatch(setGeofenceUpdateItem(value));

  const handleDeleteClick = (value) => dispatch(setGeofenceUpdateItem({ ...value, delete: true }));

  return (
    <Popup className='leaflet-popup-geofence' {...config.mapPopupOptions}>
      <Stack
        direction='column'
        sx={(theme) => ({
          fontSize: '12px',
          bgcolor: 'background.paper',
          overflow: 'hidden',
          borderRadius: theme.shape.borderRadius,
        })}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          sx={{
            padding: '10px 0',
            bgcolor: 'background.default',
            minHeight: '44px',
            '.MuiTypography-root': {
              whiteSpace: 'nowrap',
              margin: '0 12px',
              width: '100%',
              padding: '0 82px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'center',
              fontSize: '13px',
            },
          }}>
          <Stack
            direction='row'
            alignItems='center'
            component='ul'
            sx={(theme) => ({
              position: 'absolute',
              left: '-30px',
              top: '7px',
              margin: '0',
              marginLeft: 'auto',
              listStyle: 'none',
              li: {
                margin: '0',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                button: {
                  width: '30px',
                  height: '30px',
                  '.maximizeIcon, .minimizeIcon': {
                    width: '16px',
                    height: '16px',
                  },
                },
              },
              'li:nth-of-type(1) svg': {
                fontSize: '16px',
                path: {
                  fill: theme.palette.text.secondary,
                },
              },
              'li:nth-of-type(2) svg': {
                fontSize: '17px',
              },
              'li:not(:last-of-type) path': {
                fill: theme.palette.text.secondary,
              },
            })}>
            <Protect
              permissions='update'
              renderPermitted={() => (
                <li>
                  <IconButton color='default' onClick={() => handleChangeClick(value)}>
                    <ChangeGeofenceShapeIcon fontSize='small' />
                  </IconButton>
                </li>
              )}
              renderForbidden={() => <React.Fragment />}
            />
            <Protect
              permissions='update'
              renderPermitted={() => (
                <li>
                  <IconButton color='default' onClick={() => handleUpdateClick(value)}>
                    <EditOutlined fontSize='small' />
                  </IconButton>
                </li>
              )}
              renderForbidden={() => <React.Fragment />}
            />
          </Stack>
          <Typography
            variant='body1'
            sx={{
              position: 'absolute',
              width: '332px !important',
              ...(value.name.length >= 20 && {
                left: '-14px',
              }),
            }}>
            {value.name}
          </Typography>
          <Stack
            direction='row'
            alignItems='center'
            component='ul'
            sx={(theme) => ({
              position: 'absolute',
              right: '8px',
              top: '7px',
              margin: '0',
              marginLeft: 'auto',
              listStyle: 'none',
              li: {
                margin: '0',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                button: {
                  width: '30px',
                  height: '30px',
                  '.maximizeIcon, .minimizeIcon': {
                    width: '16px',
                    height: '16px',
                  },
                },
              },
              'li:nth-of-type(1) svg': {
                fontSize: '16px',
                path: {
                  fill: theme.palette.text.secondary,
                },
              },
              'li:nth-of-type(2) svg': {
                fontSize: '17px',
              },
              'li:not(:last-of-type) path': {
                fill: theme.palette.text.secondary,
              },
            })}>
            <Protect
              permissions='delete'
              renderPermitted={() => (
                <li>
                  <IconButton color='default' onClick={() => handleDeleteClick(value)}>
                    <DeleteIcon fontSize='small' />
                  </IconButton>
                </li>
              )}
              renderForbidden={() => <React.Fragment />}
            />
            <li>
              <IconButton className='leaflet-popup-close-button' color='default' onClick={onClose}>
                <Close fontSize='small' />
              </IconButton>
            </li>
          </Stack>
        </Stack>
        <Stack
          direction='row'
          sx={(theme) => ({
            display: 'grid',
            gap: 2,
            padding: theme.spacing(2),
            '.MuiPaper-root': {
              position: 'relative',
              border: 'none',
            },
            '.MuiPaper-row': {
              display: 'grid',
              gap: 1,
              gridTemplateColumns: 'repeat(5, 1fr)',
              '.MuiTypography-root:first-of-type': {
                color: 'text.secondary',
              },
            },
            '.MuiPaper-row .MuiTypography-root:first-of-type': {
              gridRow: '1',
              gridColumn: '1/3',
            },
            '.MuiPaper-row .MuiTypography-root:last-of-type': {
              gridRow: '1',
              gridColumn: '3/6',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              'span:nth-of-type(2)': {
                paddingLeft: theme.spacing(0.5),
              },
            },
          })}>
          <Paper variant='outlined'>
            <Stack className='MuiPaper-row'>
              <Typography variant='body1'>Группа</Typography>
              <Typography variant='body1'>{value.group}</Typography>
            </Stack>
            <Stack className='MuiPaper-row'>
              <Typography variant='body1'>Местоположение</Typography>
              <Typography variant='body1'>
                {value.latitude}, {value.longitude}
              </Typography>
            </Stack>
            <Stack className='MuiPaper-row'>
              <Typography variant='body1'>Адрес</Typography>
              <Typography variant='body1'>{value.location}</Typography>
            </Stack>
            {value.shape === 'Circle' && (
              <Stack className='MuiPaper-row'>
                <Typography variant='body1'>Ширина</Typography>
                <Typography variant='body1'>
                  <span>{value.radius}</span>
                  <span>м</span>
                </Typography>
              </Stack>
            )}
            <Stack className='MuiPaper-row'>
              <Typography variant='body1'>Площадь</Typography>
              <Typography variant='body1'>
                <span>{value.area}</span>
                <span>м²</span>
              </Typography>
            </Stack>
          </Paper>
        </Stack>
      </Stack>
    </Popup>
  );
};

export default MapLeafletGeofencePopup;
